import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface UpdateOwnerInvestmentRelianceAccessPayload {
  ownerUuid: string;
  uuid: string;
  relianceCanView: boolean;
}

export const useUpdateOwnerInvestmentRelianceAccess = (
  options?: UseMutationOptions<
    any,
    Error,
    UpdateOwnerInvestmentRelianceAccessPayload
  >
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateOwnerInvestmentRelianceAccess"],
    mutationFn: async ({
      ownerUuid,
      uuid,
      relianceCanView,
    }: UpdateOwnerInvestmentRelianceAccessPayload) => {
      return axiosInstance
        .patch(`/successors/${ownerUuid}/investments/${uuid}/reliance-access`, {
          relianceCanView,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa zapisywanie zmian...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-reliance-access",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zmiany zostały zapisane.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-reliance-access",
      });
      queryClient.invalidateQueries({
        queryKey: ["investments/grouped", "successor", variables.ownerUuid],
      });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji dostępu.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-reliance-access",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
